export default "__VITE_ASSET__jQoMQCDe__"